export default __webpack_public_path__ + "static/media/pattern.1d9a944c.png";